import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CartProvider } from './context/CartContext';
import WelcomePage from "./pages/Welcome/WelcomePage";
import PreferencesPage from "./pages/Preferences/PreferencesPage";
import ChatPage from "./pages/Chat/ChatPage";

function App() {
  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/" element={<WelcomePage />} />
          <Route path="/preferences" element={<PreferencesPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/chat/:chatId" element={<ChatPage />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;